// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";
import useScreenResolution from "../../../hooks/useScreenResolution";
import "./serviceCards.css";

// The 1px #DDE2E4 border is unconditional: mobile used to drop it with
// max767:border-0, which left the cards as bare grey blocks and diverged from
// the web design.
const ServiceCard = ({ icon, micon, text, handleAction, type, hideInMobile }) => (
  <div
    className={`service-cards w-full flex h-[120px] flex-col justify-between items-start flex-[1_0_0] border bg-[#F6F8F9] p-6 rounded-[10px] border-solid border-[#DDE2E4] max767:w-[110px]  max767:flex-col  max767:items-center  max767:justify-center  max767:gap-0  max767:p-4 max767:fill-current max767:text-blue-500 hover:cursor-pointer max767:h-[93px] ${hideInMobile ? "hidden" : ""}`}
    onClick={() => handleAction(type)}
  >
    <div className=" rounded-full max767:mb-0 ipad:mb-0">
      {/* <FontAwesomeIcon icon={icon} size="lg" /> */}
      <img src={icon} alt="" className="max767:hidden" />
      <img src={micon} alt="" className="hidden max767:block h-9 w-9" />
    </div>
    <div className="max767:mt-1 max767:text-center service-title text-[#1A2024] text-xl not-italic font-medium leading-[120%] ipad:text-base max767:text-sm max767:text-[#48535B]">
      {text}
    </div>
  </div>
);

const ServiceGrid = ({ services, className, serviceClickHandler }) => {
  const translate = useLanguageTranslate();
  const { mobile } = useScreenResolution()

  return (
    <div
      className={`flex justify-around policy-cards gap-4 pl-0 max767:pl-0 rtl:pr-0 pt-[8px] pb-0 px-0 max767:gap-2 max767:grid-cols-3 ${className}`}
    >
      {services.map((service) => (
        <ServiceCard
          type={service.type}
          key={service.type}
          icon={service.icon}
          micon={service.micon}
          text={translate(service.text, service.text_ar)}
          handleAction={serviceClickHandler}
          hideInMobile={service.hideInMobile && mobile}
        />
      ))}
    </div>
  );
};

export default ServiceGrid;
